import { linearConversion } from '../functions.js';

export default class RangeBubbleElement extends HTMLElement {
    
    constructor() {
        super();
    }

    connectedCallback() {

        this._range = this.querySelector('input[type=range]');
        this._bubble = this.querySelector('output');
        
        this._range.addEventListener('input', () => {
            this._setBubble();
        });
        this._setBubble();

    }

    _setBubble() {
        const val = this._range.value;
        const min = this._range.min ? this._range.min : 0;
        const max = this._range.max ? this._range.max : 100;
        let newVal = Number(((val - min) * 100) / (max - min));
        this._bubble.innerHTML = val + ' min' + (val > 1 ? 's' : '');
        // Sorta magic numbers based on size of the native UI thumb

        newVal = linearConversion(newVal, 0, 100, 10, 90);

        this._bubble.style.left = `calc(${newVal}% + (${8 - newVal * 0.15}px))`;
        // this._bubble.style.left = `${newVal}%`;
    }
};

window.customElements.define('range-bubble', RangeBubbleElement);